
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/NoAssignmentsListItem';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class='ig-row ig-row-empty'>\n  <div class='ig-empty-msg'>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("assignments.no_assignments_list_item")
  },data:data},helper ? helper.call(depth0, "assignments.no_assignments_list_item.no_assignments_in_this_group", "No assignments in this group", options) : helperMissing.call(depth0, "t", "assignments.no_assignments_list_item.no_assignments_in_this_group", "No assignments in this group", options)))
    + "\n  </div>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  